<template>
    <div class="vld-parent" style="min-height: 300px;">
        <loading 
            :active="loading || updating_project || loading_real_estate_type_map" 
            :can-cancel="false" 
            :is-full-page="false"
        />

        <valuation-subject-wizard
            v-if="valuation_subject && !loading_real_estate_type_map"
            v-model="valuation_subject"
            @finish="handleFinishClick"
            @toggleEditable="editable = !editable"
            @loading="loading = $event"
            :editable="editable"
            ref="wizard"
        />
    </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';

import { Swal } from "@/components/utils/swal.alerts.js";

import ApiService from "@/components/utils/api.service.js"
import ApiCalls from "@/components/utils/api.calls.js"

import ValuationSubjectWizard from "./ValuationSubjectWizard.vue"

import store from "./store"

export default {
    props: {
        project_id: {
            type: Number,
            required: true
        },
        new_re_key: {
            type: String,
            default: null,
            required: false
        }
    },
    data() {
        return {
            valuation_subject: null,
            loading: false,
            updating_project: false,
            editable: this.new_re_key != null,
            loading_real_estate_type_map: false,
        }
    },
    components: {
        Loading,
        ValuationSubjectWizard
    },
    methods: {
        getProjectValuationSubject: function() {
            const app = this;
            app.loading = true;
            ApiService
                .get(`/amas/project/api/${this.project_id}/valuation-subject`)
                .then(response => {
                    this.valuation_subject = response.data;
                    let requests = [];
                    this.valuation_subject.real_estates.forEach((element, element_idx) => {
                        requests.push( // Add it to array so loader is only set once!
                            ApiCalls.getRealEstateData(element.re_key)
                                .then(real_estate => {
                                    element.real_estate = real_estate;
                                    app.$set(app.valuation_subject.real_estates, element_idx, element)

                                    ApiCalls.getRealEstateGeometry(element.re_key)
                                        .then(res => {
                                            element.geom = res;
                                            app.$set(app.valuation_subject.real_estates, element_idx, element)
                                        });
                                        
                                    return real_estate;
                                })
                        )
                    })
                    Promise.all(requests).then(_results => {
                        app.valuation_subject.session_list.forEach((session, session_idx) => {
                            session = app.$refs["wizard"].setSessionValuesAsync(session);
                            app.$set(app.valuation_subject.session_list, session_idx, session);
                        })
                        if(app.new_re_key) {
                            app.$refs["wizard"]
                                .addRealEstateToSubject(app.new_re_key, "new")
                                .then(_ => {
                                    // The related real estates belong to the session just created for new_re_key, not to the project's first one.
                                    const new_session = app.$refs["wizard"].getRealEstateSessionByReKey(app.new_re_key);
                                    app.$refs["wizard"]
                                        .getValuationSubjectEstimation(
                                            app.new_re_key, new_session ? new_session.id : null)
                                        .finally(() => {
                                            app.loading = false;
                                        });
                                })
                                .catch(error => {
                                    app.loading = false;
                                    console.error(error);
                                })
                        } else {
                            app.loading = false;
                        }
                    })                    
                })
        },
        handleFinishClick: function() {
            const app = this;
            if (this.new_re_key != null) {
                // A new project, don't show this warning
                app.updateProject();
            } else {
                Swal({
                    title: this.$t("general:are_you_sure"),   
                    text: this.$t("task_details:valuation:subject_will_be_saved_steps_rerun_changes_will_be_overriden:warning"),
                    icon: "warning",   
                    showCancelButton: true,   
                    confirmButtonColor: "#2cabe3",   
                    confirmButtonText: this.$t("general:yes_confirm"),
                    cancelButtonText: this.$t("general:no_cancel"),
                }).then(async function(val){
                    if (val.isConfirmed) {
                        app.updateProject();
                    }
                });
            }
        },
        updateProject: function() {
            this.updating_project = true;
            ApiService
                .put(`/amas/project/api/${this.project_id}/valuation-subject`, this.valuation_subject)
                .then(response => {
                    this.updating_project = false;
                    Swal({
                        title: "",
                        text: this.$t("general:save:successful"),
                        icon: "success",
                    })
                    window.location.href = `/amas/project/${response.data.task_id}`;
                })
                .catch(error => {
                    this.updating_project = false;
                    let text;
                    if(error.response.status==403) {
                        text = error.response.data.code === "re_out_of_range"
                            ? this.$t("task_details:manage:re_out_of_range:description")
                            : (error.response.data.detail || error.response.data.details);
                    } else {
                        text = this.$t("general:save:admins_were_notified:error");
                    }
                    Swal({
                        title: "",
                        text: text,
                        icon: "error",
                    })
                    if(error.response.status!=403) {
                        throw error;
                    }
                })
        }
    },
    mounted() {
        this.loading_real_estate_type_map = true;
        store.dispatch("retrieveRealEstateTypeMap")
        .then(() => {
            this.getProjectValuationSubject();
        })
        .finally(() => {
            this.loading_real_estate_type_map = false;
        })
    },
}
</script>
